var map = {
	"./additionalInfoIcon.svg": 607,
	"./arrowLeftIcon.svg": 608,
	"./arrowMediumTop.svg": 609,
	"./arrowRightIcon.svg": 610,
	"./arrowRightIconSharp.svg": 611,
	"./arrowRightSmallIcon.svg": 612,
	"./arrowScalableIcon.svg": 613,
	"./arrowSelect2.svg": 614,
	"./arrowSelectIcon.svg": 615,
	"./benefit1.svg": 616,
	"./benefit2.svg": 617,
	"./benefit3.svg": 618,
	"./cardsIcon.svg": 619,
	"./checkCirсleIcon.svg": 620,
	"./circleInfoIcon.svg": 621,
	"./copyIcon copy.svg": 622,
	"./copyIcon.svg": 623,
	"./crossIcon.svg": 624,
	"./crossIcon2.svg": 625,
	"./crossIcon3.svg": 626,
	"./crossIconSmall.svg": 627,
	"./crossSmallIcon.svg": 628,
	"./defaultCategoryIcon.svg": 629,
	"./depNumberIcon.svg": 630,
	"./elfCentralIcon.svg": 631,
	"./equalitySign.svg": 632,
	"./errorIcon.svg": 633,
	"./eyeClosedIcon.svg": 634,
	"./eyeOpenIcon.svg": 635,
	"./favoritesIcon.svg": 636,
	"./favoritesLabelIcon.svg": 637,
	"./filterDivider.svg": 638,
	"./filterIcon.svg": 639,
	"./frequencyIcon.svg": 640,
	"./fsAmountIcon.svg": 641,
	"./fullScreenIcon.svg": 642,
	"./gameIcon.svg": 643,
	"./goldGiftIcon.svg": 644,
	"./hamburgerIcon.svg": 645,
	"./infoIcon.svg": 646,
	"./infoSymbol.svg": 647,
	"./levelBackground.svg": 648,
	"./levelBackgroundNew.svg": 649,
	"./linkIcon.svg": 650,
	"./lockIcon.svg": 651,
	"./lockSharpIcon.svg": 652,
	"./maxBonusAmountIcon.svg": 653,
	"./maxWinFsIcon.svg": 654,
	"./menu/fortuneIcon.svg": 373,
	"./menu/fortuneIconL.svg": 374,
	"./menu/helpdeskIcon.svg": 375,
	"./menu/helpdeskIconL.svg": 376,
	"./menu/homeIcon.svg": 377,
	"./menu/homeIconLarge.svg": 378,
	"./menu/jackpotIcon.svg": 379,
	"./menu/logo.svg": 380,
	"./menu/logoSmall.svg": 381,
	"./menu/loyaltyIcon.svg": 382,
	"./menu/mobileAppIcon.svg": 383,
	"./menu/profileIcon.svg": 384,
	"./menu/questIcon.svg": 385,
	"./menu/questsIcon.svg": 386,
	"./menu/rewardLineupIcon.svg": 387,
	"./menu/searchIcon.svg": 388,
	"./menu/searchIconLarge.svg": 389,
	"./menu/signOutIcon.svg": 390,
	"./menu/star.svg": 391,
	"./menu/tournamentIcon.svg": 392,
	"./menu/tournamentLargeIcon.svg": 393,
	"./menu/vipIcon.svg": 394,
	"./menu/wheelIcon.svg": 395,
	"./menu/wheelIconL.svg": 396,
	"./menu/wheelIconMobile.svg": 397,
	"./menuIcon.svg": 655,
	"./minDepIcon.svg": 656,
	"./noTournamentIcon.svg": 657,
	"./numbers/number-1.svg": 398,
	"./numbers/number-2.svg": 399,
	"./numbers/number-3.svg": 400,
	"./numbers/number-4.svg": 401,
	"./numbers/number-5.svg": 402,
	"./numbers/number-6.svg": 403,
	"./numbers/number-7.svg": 404,
	"./numbers/number-8.svg": 405,
	"./numbers/number-9.svg": 406,
	"./numbers/number-shine-1.svg": 407,
	"./numbers/number-shine-2.svg": 408,
	"./numbers/number-shine-3.svg": 409,
	"./numbers/number-shine-4.svg": 410,
	"./numbers/number-shine-5.svg": 411,
	"./numbers/number-shine-6.svg": 412,
	"./numbers/number-shine-7.svg": 413,
	"./numbers/number-shine-8.svg": 414,
	"./numbers/number-shine-9.svg": 415,
	"./playIcon.svg": 658,
	"./polygon.svg": 659,
	"./preloaderDotsAnimation.svg": 660,
	"./preloaderSpinnerAnimation.svg": 661,
	"./presentIcon.svg": 662,
	"./promoIcon.svg": 663,
	"./recentIcon.svg": 664,
	"./search2Icon.svg": 665,
	"./search3Icon.svg": 666,
	"./sharpTickIcon copy.svg": 667,
	"./sharpTickIcon.svg": 668,
	"./smallInfoSymbol.svg": 669,
	"./smoothArrowIcon.svg": 670,
	"./successIcon.svg": 671,
	"./supportIcon.svg": 672,
	"./tag1Icon.svg": 673,
	"./tag2Icon.svg": 674,
	"./tag3Icon.svg": 675,
	"./tag4Icon.svg": 676,
	"./tickIcon.svg": 677,
	"./unverified.svg": 678,
	"./verified.svg": 679,
	"./wagerIcon.svg": 680,
	"./wagerTimeIcon.svg": 681,
	"./warningIcon.svg": 682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 606;